/* eslint-disable global-require */
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import './i18n';
import { IS_CASINO_ENABLED } from '../crm/helpers/Constants';
import { isGGWorld } from '../utils/template';

import loadComponent from './loadComponent';

const notificationsEnabled = process.env.MIX_NOTIFICATIONS_ENABLED?.toLowerCase() === 'true';
const winnersToastEnabled = process.env.MIX_WINNERS_TOAST_ENABLED?.toLowerCase() === 'true';

if (notificationsEnabled) {
    loadComponent('notifications/NotificationBell', 'notification-dropdown');
}
if (winnersToastEnabled) {
    loadComponent('winners-toast/WinnersToast', 'winners-toast');
}

loadComponent('results/ResultsDetails', 'results-details');

loadComponent('my-account/AccountDetails/AccountDetails', 'account-details');

loadComponent('my-account/Header/Balance', ['account-details-balance', 'account-details-balance-mobile']);

loadComponent('my-account/Header/AvailableDebit', [
    'account-details-available-debit',
    'account-details-available-debit-mobile',
]);

loadComponent('my-account/Header/Earnings', ['account-details-earnings', 'account-details-earnings-mobile']);

loadComponent('my-account/EditProfile/EditProfile', 'edit-profile-form');

loadComponent('my-account/EditProfile/ChangeEmail/ChangeEmail', 'change-email-form');

loadComponent('my-account/EditProfile/ChangePassword/ChangePassword', 'change-password-form');

loadComponent('my-account/EditProfile/ChangePhone/ChangePhone', 'change-phone-form');

loadComponent('my-account/DeactivateAccount/DeactivateAccount', 'deactivate-account-form');

loadComponent('my-account/MyTickets/MyTickets', 'account-my-tickets');

loadComponent('my-account/MyTickets/SingleTicket', 'account-my-tickets-single');

loadComponent('my-account/MyTickets/SingleMultiDrawTicket', 'account-my-tickets-single-multidraw');

loadComponent('my-account/MyTransactions/MyTransactions', 'account-my-transactions');

loadComponent('my-account/MyTransactions/SingleDeposit', 'account-transaction-deposit');

loadComponent('my-account/MyTransactions/SingleWithdrawal', 'account-transaction-withdrawal');

loadComponent('my-account/MyTickets/SingleLootboxTicket', 'component--account-my-tickets-lootbox-single');

loadComponent('latest-results/LatestResults', 'latest-results');

loadComponent('latest-winners/LatestWinners', 'latest-winners');

require('../components/current-jackpot/CurrentJackpot');

loadComponent('jackpot/JackpotBanner', 'jackpot-banner');

loadComponent('keno-counter/KenoCounter', ['keno-counter', 'keno-counter-bottom']);

loadComponent('counters/UniversalDrawCounterLoader', 'universal-draw-counter');

loadComponent('homepage/lottery-list/DrawDateCounterLoader', 'draw-date-counter', '...');

require('../components/user/user-panel/UserPanel');

loadComponent('my-account/MySalesAccount/MySalesAccount', 'account-my-sales-account');

loadComponent('my-account/MySalesAccount/ShowCustomer', 'account-my-sales-account-single');

loadComponent('my-account/MySalesAccount/CustomerForm', 'account-my-sales-account-form');

loadComponent('my-account/MySalesAccount/Earnings', 'account-my-sales-earnings');

loadComponent('my-account/Voucher/VoucherCode', 'voucher-code');

loadComponent('user/user-panel/BalanceElement', 'user-panel-balance');

loadComponent('promo-codes/PromoCode', 'promo-code');

loadComponent('payment-method-channels/PaymentMethodChannels', 'payment-method-channels');

loadComponent('play/PlayWrapper', 'play-picker');

loadComponent('notifications/NotificationsWrapper', 'notifications-wrapper');

require('../components/sliders/Sliders');

loadComponent('faq/Faq', 'faq-component');
loadComponent('faq/FaqCategory', 'faq-category-component');

loadComponent('mobile-app-download-banner/MobileAppDownloadBanner', 'component--mobile-app-download-banner');

loadComponent('homepage/News/News', 'homepage-news');

loadComponent('Deposits/DepositFinalStatusRedirector', 'deposit-final-status-redirector');

loadComponent('default/Header', 'component--header');

loadComponent('default/Homepage/Slider/LotterySlider', 'lottery-slider');

loadComponent('default/Homepage/Casino/CasinoWrapper', 'casino-wrapper');

loadComponent('Deposits/DepositFinalStatusRedirector', 'deposit-final-status-redirector');

loadComponent('my-account/Deposit/Deposit', 'deposit-form');

loadComponent('default/MyAccount/AccountMenu', 'account-menu');

loadComponent('default/MyAccount/AccountMenuHeader', 'account-menu-header');

loadComponent('default/MyAccount/Promote/Promote', 'my-account-promote');

loadComponent('default/MyAccount/Overview/TicketsOverview', 'my-account-tickets-overview');

loadComponent('default/MyAccount/Overview/TransactionsOverview', 'my-account-transactions-overview');

loadComponent('default/MyAccount/Overview/CasinoTransactionsOverview', 'my-account-casino-transactions-overview');

loadComponent('register/RegisterWraper', 'register_form');

require('../components/homepage/lottery-list/LotteryList');

if (IS_CASINO_ENABLED) {
    require('../casino/Base/ReactCasino');
}

if (isGGWorld()) {
    loadComponent('homepage/header/templates/gg-world/MainHeader', 'main-header');
    loadComponent('homepage/rules/templates/gg-world/RuleTiers', 'rule-tiers');
}

document.addEventListener('DOMContentLoaded', function () {
    if ('Notification' in window && Notification.permission !== 'granted') {
        // Request user for permissions to send notification.
        Notification.requestPermission();
    }
});

loadComponent('homepage/sliders/CasinoGamesCarouselSliders', 'casino-games-carousel-sliders');
loadComponent('lootbox/Lootbox', 'component--lootbox');
